import { render, staticRenderFns } from "./EmailModification.vue?vue&type=template&id=7800f8fa&scoped=true&"
import script from "./EmailModification.vue?vue&type=script&lang=js&"
export * from "./EmailModification.vue?vue&type=script&lang=js&"
import style0 from "./EmailModification.vue?vue&type=style&index=0&id=7800f8fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7800f8fa",
  null
  
)

export default component.exports